import { Model } from "../Model";

export class PaymentMethod extends Model {

  constructor(id: number, attributes: any) {
    super(id);
  }

}